import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import { setShowIntercom } from 'actions'
import { languages, mapLanguageToComponentProps } from 'i18n'
import NavigationBar from 'components/navigation-bar'
import { setUnpublished } from 'careers/actions/job-ad'
import { httpError } from 'actions/http'
import UrlLanguage from 'components/url-language'
import ThemeProvider from 'theme/ThemeProvider'
import { getPrimaryColors } from 'theme/branding/custom-colors'
import { AppContent } from 'components/styled/page/app-content'
import CandidateFooter from 'components/candidate-footer'
import { BrandingType } from 'types'
import { Outlet, useParams, useLocation } from 'react-router-dom'
import IntercomWrapper from 'chat-bots/intercom-wrapper'
import * as analytics from 'analytics/performance'
import config from 'config/config'

interface CareersAppProps {
  company: {
    branding: BrandingType
  }
  dispatch: any
}

const mapStateToProps = (state: any) => ({
  company: state.careers.company,
})

export function CareersApp({ company, dispatch }: CareersAppProps) {
  const { branding } = company
  const { referrer } = document
  const params: any = useParams()
  const location = useLocation()

  useEffect(() => {
    dispatch(httpError(null))
    dispatch(setUnpublished(false))
    // disable analytics if already initialized
    if (config.DISABLE_CANDIDATE_ANALYTICS) {
      analytics.disableAnalytics([analytics.AnalyticsService.Amplitude])
    }
    dispatch(setShowIntercom())
  }, [location.pathname, dispatch])

  useEffect(() => {
    const dir = params.language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.dir = dir
  }, [params.language])

  if (
    referrer &&
    document.cookie.indexOf('referrer=') < 0 &&
    !referrer.includes(
      'https://www.linkedin.com/uas/login?session_redirect=%2Foauth'
    )
  ) {
    document.cookie = `referrer=${referrer}; expires=${moment()
      .add(7, 'days')
      .utc()
      .toString()}`
  }
  const link = `/careers/${params.language}/${params.companySlug}`

  const {
    headerFont,
    bodyFont,
    backgroundColor,
    textColor,
    brandColor,
    buttonTextColor,
    headerTextColor,
  } = branding ?? {}

  const primaryColors = brandColor ? getPrimaryColors(brandColor) : undefined
  const customTheme = branding
    ? {
        color: {
          ...primaryColors,
          headerText: headerTextColor,
          bodyText: textColor,
          primaryButtonText: buttonTextColor,
          background: backgroundColor,
        },
        font: {
          primary: bodyFont,
          header: headerFont,
        },
      }
    : undefined

  return (
    <ThemeProvider customTheme={customTheme} useGlobalStyle customizeLink>
      <AppContent footer={<CandidateFooter />}>
        <UrlLanguage params={params} languages={languages} />
        {params.adSlug && (
          <NavigationBar
            routePrefix={link}
            className="navigation-bar careers"
            language={params.language}
          />
        )}
        <IntercomWrapper />
        <Outlet />
      </AppContent>
    </ThemeProvider>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(CareersApp)
